// extracted by mini-css-extract-plugin
module.exports = {"container":"ujmDR","left":"_2TQ10","right":"_1dCY9","moreButton":"_1WSPX","image":"_3pq8u","title":"JJWc5","collapsedPart":"_1Czzc"};